module.exports = {
  title: '意见反馈',
  route: {
    path: '/admin-system-manage',
    children: {
      path: 'system-complaints-suggestions',
    },
  },
};
